import { render, staticRenderFns } from "./eBikeDetailsDialog.vue?vue&type=template&id=513c5c30&scoped=true"
import script from "./eBikeDetailsDialog.vue?vue&type=script&lang=js"
export * from "./eBikeDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./eBikeDetailsDialog.vue?vue&type=style&index=0&id=513c5c30&prod&lang=scss"
import style1 from "./eBikeDetailsDialog.vue?vue&type=style&index=1&id=513c5c30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513c5c30",
  null
  
)

export default component.exports